import { useQuery } from '@tanstack/react-query';
import { getCmsDataInterface } from './interface';
import { getCmsData } from '../..';

interface UseGetCmsDataProps {
  params: getCmsDataInterface;
  enabled?: boolean;
}

const useGetCmsData = ({ params, enabled = true }: UseGetCmsDataProps) => {
  const {
    data: cmsData,
    isLoading: isCmsDataLoading,
    isSuccess: isCmsDataSuccess,
    refetch: refetchCmsData,
  } = useQuery({
    queryKey: ['cmsData', params],
    queryFn: () => getCmsData(params),
    enabled:
      enabled &&
      !!params.pageType &&
      !!params.pageName &&
      !!params.collectionType,
    refetchOnMount: false,
  });

  return {
    cmsData,
    isCmsDataLoading,
    isCmsDataSuccess,
    refetchCmsData,
  };
};

export default useGetCmsData;
